'use client';

import { useDataLayerEventOnPageLoad } from '@coolblue-development/next-analytics/client';
import { AvailabilityStates } from '@coolblue-development/next-availability-state';

type Props = {
  product: {
    id: number;
    availabilityState: string;
    brand?: { id?: string | number | null } | null;
    productType?: { productTypeId?: string | number | null } | null;
    salesPrice?: { includingVat?: number | null } | null;
  };
};

function mapAvailabilityState(availabilityState: string): string {
  switch (availabilityState) {
    case AvailabilityStates.AvailableSoon:
      return 'available-soon';
    case AvailabilityStates.OnStock:
      return 'on-stock';
    case AvailabilityStates.TemporaryOutOfStock:
      return 'temporary-out-of-stock';
    case AvailabilityStates.OutOfStock:
      return 'permanently-out-of-stock';
    case AvailabilityStates.PreOrder:
      return 'pre-order';
    default:
      return '';
  }
}

export const ProductDataLayerClient = ({ product }: Props) => {
  const googleTagParams: {
    [key: string]: string | number;
  } = {
    ecomm_pagetype: 'product',
    ecomm_prodid: product.id,
    ecomm_availability: mapAvailabilityState(product.availabilityState),
    ecomm_quantity: 1
  };

  if (product.brand?.id) {
    googleTagParams.ecomm_brandid = Number(product.brand.id);
  }

  if (product.productType?.productTypeId) {
    googleTagParams.ecomm_ptype = Number(product.productType.productTypeId);
  }

  if (product.salesPrice?.includingVat) {
    googleTagParams.ecomm_pvalue = Number(product.salesPrice.includingVat);
  }

  useDataLayerEventOnPageLoad([
    {
      google_tag_params: googleTagParams
    }
  ]);
  return null;
};
